import { ContactManager } from '@copilot/data';
import { ContactActions } from '@copilot/common/store/actions/contact';
import { useStoreLoader } from '../common';

export const useContact = (id: string) => {
	useStoreLoader(ContactActions.loadContact, () => ContactManager.getContact(id));
};
